import { render, staticRenderFns } from "./AddClients.vue?vue&type=template&id=49978708&scoped=true"
import script from "./AddClients.vue?vue&type=script&lang=js"
export * from "./AddClients.vue?vue&type=script&lang=js"
import style0 from "./AddClients.vue?vue&type=style&index=0&id=49978708&prod&scoped=true&lang=scss"
import style1 from "./AddClients.vue?vue&type=style&index=1&id=49978708&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49978708",
  null
  
)

export default component.exports